import React, { memo } from 'react'
import {
	useAppDispatch
} from '../../../../shared/lib/hooks/useAppDispatch/useAppDispatch'
import { modalActions, ModalTypes } from '../../../../entities/Modal'
import { SvgIcon } from '../../../../shared/ui/SvgIcon/SvgIcon'
import Button from '@mui/material/Button'
import { faPenToSquare } from '@fortawesome/free-solid-svg-icons/faPenToSquare'
import Tooltip from '@mui/material/Tooltip'
import { NotificationWithSubscribers } from '../../../../entities/Notifications'

interface NotificationsActionsProps {
	notification: NotificationWithSubscribers
}

export const NotificationsActions = memo(
	function AppsActions(props: NotificationsActionsProps) {
		const { notification } = props
		const dispatch = useAppDispatch()

		const handleEdit = () => {
			dispatch(modalActions.showModal({
				modalType: ModalTypes.EDIT_NOTIFICATION_SUBSCRIBERS_MODAL,
				data: notification
			}))
		}

		return (
			<Tooltip title="Edit subscribers" placement="top">
				<Button
					size="large"
					onClick={handleEdit}
				>
					<SvgIcon icon={faPenToSquare} />
				</Button>
			</Tooltip>
		)
	})